import { SITE } from "@/config";
import { BuyButton } from "@/components/BuyButton";
import { Reveal } from "@/lib/motion";

export const FinalCTA = () => (
  <section className="bg-ink py-24 md:py-32" data-testid="final-cta-section">
    <div className="mx-auto max-w-4xl px-6 text-center md:px-12">
      <Reveal>
        <h2 className="font-display text-4xl font-medium leading-[1.02] tracking-tight text-white sm:text-6xl">
          Make leaving a review effortless.
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-white/60">
          One tap between your customer and your Google review page.
        </p>

        <div className="mt-10 flex flex-col items-center justify-center gap-5 sm:flex-row">
          <span className="font-display text-3xl font-semibold tracking-tight text-white">
            {SITE.price}
          </span>
          <BuyButton variant="light" testId="buy-now-final" className="px-9 py-4 text-base">
            Buy now
          </BuyButton>
        </div>

        <p className="mt-6 text-sm text-white/45">
          Configured for your business · No subscription · No app required
        </p>
      </Reveal>
    </div>
  </section>
);
